import { render } from "./IconPlusStroke.vue?vue&type=template&id=17454fe1"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconPlusStroke.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17454fe1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17454fe1', __exports__)) {
    api.reload('17454fe1', __exports__)
  }
  
  module.hot.accept("./IconPlusStroke.vue?vue&type=template&id=17454fe1", () => {
    api.rerender('17454fe1', render)
  })

}


export default __exports__